import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { fetchUserAttributes } from "aws-amplify/auth";

const Card = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  text-align: center;
`;

const Avatar = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #001a3d;
  color: white;
  font-size: 2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
`;

const Heading = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

const Subtext = styled.p`
  font-size: 0.95rem;
  color: #555;
`;

export default function Profile() {
  const [name, setName] = useState("Skrooper");

  useEffect(() => {
    async function loadName() {
      try {
        const attrs = await fetchUserAttributes();
        const displayName = attrs.name?.trim() || attrs.email?.trim() || "Skrooper";
        setName(displayName);
      } catch (err) {
        console.warn("Unable to load user name:", err);
      }
    }

    loadName();
  }, []);

  const initials = name
    .split(" ")
    .map((w) => w[0]?.toUpperCase())
    .join("")
    .slice(0, 2);

  return (
    <Card>
      <Avatar>{initials}</Avatar>
      <Heading>Welcome, {name}!</Heading>
      <Subtext>This is your Skroop account.</Subtext>
    </Card>
  );
}
